// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"b870d68d","120":"10a4694b","429":"22f94eca","482":"696532fb","714":"9968bd36","849":"5437436d","871":"21bd03c1"}[chunkId] + ".chunk.js";
};